import { createGlobalStyle } from 'styled-components';

import drawer from './components/drawer';
import reset from './components/reset';
import swal from './components/swal';
import theme from './themes/default';

export default createGlobalStyle`
  ${reset} 

	html {
    scroll-behavior: smooth;
		font-size: 16px;
  }

  #__next,
  html,
  body {
    display: flex;
    flex-flow: column;

    margin: 0;
    padding: 0;
    border: 0;

		min-height: 100%;
		height: 100%;
  }

  p, span, small, label,
  button, input, textarea,
  td, li,  div,
  h1, h2,h3, h4, h5, h6, strong, b, em {
    font-family: ${theme.font.default}, sans-serif;
  }
 
  #__next  {
    height: 100%;
    flex: 1;
  }
	
	picture {
		display: block;
	}
  img {
    max-width: 100%;
		display: block;
  }

  button {
    background: none;
    border: none;
  }

  h1 {
    font-size: 2.25em;
    font-weight: 500;
    @media (max-width: 991px) {
      font-size: 1.5em;
    }
  }
  h2 {
    font-size: 2em;
    font-weight: 500;
    @media (max-width: 991px) {
      font-size: 1.17em;
    }
  }
  h3 {
    font-size: 1.125em;
    font-weight: 700;
    color: ${theme.colors.texts};
    @media (max-width: 991px) {
      font-size: 1em;
    }
  }
  h4 {
    font-size: 1em;
		font-weight: 600;
    @media (max-width: 991px) {
      font-size: 0.83em;
    }
  }
  h5 {
    font-size: 0.875em;
		font-weight: 700;
    @media (max-width: 991px) {
      font-size: 0.67em;
    }
  }
  h6 {
    font-size: 0.67em;
		font-weight: 600;
    @media (max-width: 991px) {
      font-size: 0.5em;
    }
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-bottom: 1.2rem;
    color: ${theme.colors.title};
  }
  
  p, td, li, div, a, div, button {
    font-size: 1rem;
    /* letter-spacing: -0.02em;  */
    color: ${theme.colors.title};
  }
  
  p, td, li, div, a, button {
    line-height: 150%;
  }

  p {
    margin-bottom: 1rem;

		small {
			font-size: 90%;
			line-height: 0.9rem;
			display: inline-block;
		}

    span {
      font-size: inherit;
    }
 
  }

  span  {
    font-size: 0.8rem;
  }

	a {
    color: ${theme.colors.title};
	}

  input {
    @media (max-width: 991px) {
      font-size: 1rem !important;
    }
  }

  button {
    cursor: pointer;
  }

  hr {
    margin: 2rem 0; 
    opacity: 0.6;
    border: 1px solid ${theme.colors.border};
  }

  /* - - - - - - - -  Utils - - - - - - - - */

  .loading-page {
    background-image: url('/images/loading.gif');
    background-color: ${theme.colors.light.color};
    background-position: center center;
    background-repeat: no-repeat;
    background-size: 2.8125rem;
    opacity: 0;
    min-height: 100vh;
  }
 
  /* Vendor Fix */
  .swal2-container {
    z-index: 99999 !important;
  }
  .swal2-styled:focus {
    box-shadow: none;
  }

  .customSelect__menu {
    z-index: 100 !important;
  } 

  ${swal}
  ${drawer}
`;
